import React from "react";
import {Formik} from "formik";

import {SSO_USERS} from "./constants";
import {SSOConfirmationModal} from "./SSOConfirmationModal";
import {useSsoConfirmationModal} from "./hooks/useSsoConfirmationModal";
import {
  type SsoFormikValues,
  type SsoFormValues,
} from "./confirmationModalConstants";
import {SSOStatusCard} from "./SSOStatusCard";
import {SSOUsersCard} from "./SSOUsersCard";

type FormValues = SsoFormikValues;

export const SSOManagementCardGroup = ({
  ssoEnabled,
  ssoExcludeRequiredRoles,
}: {
  ssoEnabled: boolean;
  ssoExcludeRequiredRoles: string[] | null;
}): JSX.Element => {
  const {modalProps, openModal, initialFormikValues, revertFormToInitial} =
    useSsoConfirmationModal({ssoEnabled, ssoExcludeRequiredRoles});

  const createStatusChangeHandler =
    (form: {values: FormValues; setValues: (v: FormValues) => void}) =>
    (enabled: boolean) => {
      const pending: SsoFormValues = {
        ssoEnabled: enabled,
        ssoUsers: null,
      };
      revertFormToInitial(form.setValues);
      openModal(pending);
    };

  const createUsersChangeHandler =
    (form: {values: FormValues; setValues: (v: FormValues) => void}) =>
    (event: React.FormEvent<HTMLInputElement>) => {
      const newSsoUsers = (event.target as HTMLInputElement)
        .value as (typeof SSO_USERS)[keyof typeof SSO_USERS];
      const pending: SsoFormValues = {
        ssoEnabled: true,
        ssoUsers: newSsoUsers,
      };
      revertFormToInitial(form.setValues);
      openModal(pending);
    };

  return (
    <Formik<FormValues>
      initialValues={initialFormikValues}
      onSubmit={() => {}}
      enableReinitialize
    >
      {form => {
        const {values, setValues} = form;
        const formState = {values, setValues};
        return (
          <>
            <SSOStatusCard
              ssoEnabled={values.ssoEnabled}
              onStatusChange={createStatusChangeHandler(formState)}
              form={form}
            />

            {values.ssoEnabled && (
              <SSOUsersCard
                onUsersChange={createUsersChangeHandler(formState)}
              />
            )}

            <SSOConfirmationModal {...modalProps} />
          </>
        );
      }}
    </Formik>
  );
};
